import { LOST_STATUSES, PIPELINE_ORDER, type DriverStatus } from "./types";

/** Backend `validate_transition` bilan bir xil qoidalar: foydalanuvchi mumkin bo'lmagan variantni ko'rmasin */
export function allowedTargets(current: DriverStatus, manager: boolean): DriverStatus[] {
  if (current === "hired") return manager ? ["quit", "orientation"] : ["quit"];
  if (LOST_STATUSES.includes(current)) return ["contacted", "qualified", ...LOST_STATUSES.filter((s) => s !== current)];
  return [...PIPELINE_ORDER.filter((s) => s !== current), ...LOST_STATUSES];
}

/** Shu holatlarga o'tish uchun ish (job) kerak -- backend qoidasi bilan bir xil */
export const NEEDS_JOB: DriverStatus[] = ["submitted", "background_check", "orientation", "hired"];
